import PromotionModal from '@basicComponents/sequential-modal/promotion-modal';
import React, {useCallback, useEffect} from 'react';
import {sequentialStorage} from '@utils/Storage/SequentialStorage';
import {useModalManager} from '@basicComponents/sequential-modal/ModalManagerProvider';
import HomeYue from './home-yue';
import {getReward} from '@/common-pages/luckyspin/luckyspin.service';
import globalStore from '@services/global.state';
import CheckInModal, {CHECK_IN_NAME} from '@basicComponents/check-in-modal';
import Rewarded, {
  DOWNLOAD_REWARDED,
} from '@businessComponents/down-app-modal/rewarded';
import RewardSuccess, {
  DOWNLOAD_GET_REWARD,
} from '@businessComponents/down-app-modal/reward-success';
import NoReward, {
  DOWNLOAD_NO_REWARDED,
} from '@businessComponents/down-app-modal/no-reward';
import {
  claimRewardDownloadReward,
  getExchangeAutoCode,
  getRewardStatus,
} from '@/pages/home/home.service';
import {inApp} from '@utils';
import ExchangeRewardSuccess, {
  EXCHANGE_REWARD_SUCCESS,
} from './exchange-reward-success';
import RechargeBonusContent from './recharge-bonus-content';
import RechargeGiftModal from './recharge-gift/RechargeGiftModal';
import {
  getCurrentRechargeGift,
  type RechargeGiftScene,
  type RechargeGiftTier,
} from './recharge-gift/recharge-gift.service';
import {
  filterRechargeGiftRouteEntries,
  hasAvailableRechargeGiftTier,
} from './recharge-gift/recharge-gift-eligibility';
import {
  canShowRechargeGiftPopup,
  markRechargeGiftPopupShown,
} from './recharge-gift/recharge-gift-popup-count';

const HOME_SEQUENTIAL = 'home-sequential';
const REWARD_TITLE = 'reward';
const RECHARGE_BONUS_POPUP_TITLE = 'RechargeBonusPopup';
const RECHARGE_GIFT_TITLE = 'RECHARGE_GIFT_EVENT';

interface RechargeGiftPopupData extends RechargeGiftTier {
  title: typeof RECHARGE_GIFT_TITLE;
  scene: RechargeGiftScene;
  bannerId?: string | number;
}

const getRechargeGiftPopupData = async (
  triggerItem: any,
): Promise<RechargeGiftPopupData | null> => {
  if (!globalStore.token) {
    return null;
  }
  const gift = await getCurrentRechargeGift('LOGIN_HOME').catch(() => null);
  const hasEnabledTier = hasAvailableRechargeGiftTier(gift);
  if (
    !gift ||
    !hasEnabledTier ||
    !canShowRechargeGiftPopup(gift.dailyPopupLimit)
  ) {
    return null;
  }
  return {
    ...gift,
    title: RECHARGE_GIFT_TITLE,
    scene: 'LOGIN_HOME',
    bannerId: triggerItem.bannerId,
  };
};

const getRechargeBonusRewardAmount = (popUrl?: string) => {
  if (!popUrl || typeof popUrl !== 'string') {
    return 0;
  }
  const [, query = ''] = popUrl.split('?');
  if (!query) {
    return 0;
  }
  const amount = Number(new URLSearchParams(query).get('rewardAmount'));
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};

const shouldShowSequentialItem = (item: any) => {
  if (item.title !== RECHARGE_BONUS_POPUP_TITLE) {
    return true;
  }
  return getRechargeBonusRewardAmount(item.popUrl) > 0;
};

const getExchangeAmount = (data: any) => {
  if (!data || typeof data !== 'object') {
    return 0;
  }
  return Number(data.totalAmount) || 0;
};
const rewardModalData = async () => {
  if (!globalStore.token) {
    return null;
  }
  const res = await getReward();
  if (res) {
    return {
      rewardAmount: res.rewardAmount,
      step: res.stage,
      title: REWARD_TITLE,
    };
  }
  return null;
};

const sequentialData = () => {
  return sequentialStorage.remindData;
};
const shouldShowDailyExtraModal = (title?: string) => {
  return !!title && !sequentialStorage.isSequentialConsumed(title);
};
// 1. 如果是h5环境，判断当前用户是否领取过奖励
//   a.领取过 显示下载
//   b. 未领取过，显示奖励金额
//  2. 如果是app环境
// 通过接口返回的数据，如果存在奖励金额，那么弹窗DOWNLOAD_GET_REWARD
const getUserDownloadData = async () => {
  if (!globalStore.token) {
    return null;
  }
  const {hasUnclaimed, hasClaimed, unclaimedAmount} = await getRewardStatus();
  // H5环境处理
  if (!inApp) {
    if (!hasUnclaimed || !unclaimedAmount) {
      // 已领取过奖励，显示下载
      // return {
      //   title: DOWNLOAD_REWARDED,
      // };
      return null;
    } else {
      // 未领取过，显示奖励金额
      return {
        title: DOWNLOAD_NO_REWARDED,
        hasUnclaimed,
        hasClaimed,
        unclaimedAmount,
      };
    }
  }
  // App环境处理
  if (hasUnclaimed) {
    // 有未领取奖励，弹窗领取
    const res = await claimRewardDownloadReward();
    if (res.totalAmount) {
      return {
        title: DOWNLOAD_GET_REWARD,
        ...res,
      };
    }
    return null;
  }
  // App环境下已领取或无奖励情况
  return null;
};

const exchangeRewardData = async () => {
  if (!globalStore.token) {
    return null;
  }
  const res = await getExchangeAutoCode();
  const rewardAmount = getExchangeAmount(res);
  if (!rewardAmount) {
    return null;
  }
  return {
    title: EXCHANGE_REWARD_SUCCESS,
    totalAmount: rewardAmount,
    ...(res && typeof res === 'object' ? res : {}),
  };
};
export default function HomeSequential() {
  const {showModal, hideModal, currentModalId} = useModalManager();
  const sortPop = (data: any[]) => {
    return data.sort((a, b) => {
      const getPriority = (item: any) => {
        if (
          [
            EXCHANGE_REWARD_SUCCESS,
            DOWNLOAD_GET_REWARD,
            DOWNLOAD_REWARDED,
            DOWNLOAD_NO_REWARDED,
            RECHARGE_BONUS_POPUP_TITLE,
          ].includes(item.title)
        ) {
          return 1;
        }
        if (item.title === REWARD_TITLE) {
          return 2;
        }
        if (item.title === RECHARGE_GIFT_TITLE) {
          return 2;
        }
        if (item.title === CHECK_IN_NAME) {
          return 3;
        }
        return 4;
      };
      return getPriority(a) - getPriority(b);
    });
  };
  const checkPop = (data: any[]) => {
    const isHomePage = location.href.indexOf('/index/home') > -1;
    const modalData = isHomePage
      ? data
      : data.filter(item => item.title === EXCHANGE_REWARD_SUCCESS);

    const modals = sortPop(modalData)
      .map(item => {
        if (item.title === EXCHANGE_REWARD_SUCCESS) {
          return <ExchangeRewardSuccess key={item.title} {...item} />;
        }
        if (item.title === DOWNLOAD_REWARDED) {
          return <Rewarded key={item.title} />;
        }
        if (item.title === DOWNLOAD_NO_REWARDED) {
          // 未领取
          return <NoReward key={item.title} amount={item.unclaimedAmount} />;
        }
        if (item.title === DOWNLOAD_GET_REWARD) {
          return <RewardSuccess key={item.title} {...item} />;
        }
        if (item.title === REWARD_TITLE) {
          return (
            <HomeYue
              key={item.title}
              step={item.step}
              reward={item.rewardAmount}
            />
          );
        }
        if (item.title === RECHARGE_BONUS_POPUP_TITLE) {
          return (
            <RechargeBonusContent
              key={item.bannerId}
              imageUrl={item.popImg}
              rewardAmount={getRechargeBonusRewardAmount(item.popUrl)}
              openUrl={item.popUrl}
            />
          );
        }
        if (item.title === RECHARGE_GIFT_TITLE) {
          return (
            <RechargeGiftModal
              key={item.bannerId}
              gift={item}
              scene={item.scene}
              onShown={() => markRechargeGiftPopupShown(item.dailyPopupLimit)}
              sequentialConsume={false}
              sequentialOverlayClassName="bg-black/80"
              sequentialTransitionDuration={0.18}
              sequentialTransitionType="zoom-in-out"
            />
          );
        }
        if (item.title === CHECK_IN_NAME) {
          if (globalStore.token) {
            return <CheckInModal key={item.bannerId} />;
          }
          return null;
        }
        return (
          <PromotionModal
            key={item.bannerId}
            imageUrl={item.popImg}
            openUrl={item.popUrl}
          />
        );
      })
      .filter(Boolean);

    if (modals.length > 0) {
      showModal({
        id: HOME_SEQUENTIAL,
        modals,
      });
    }
  };
  const updatePops = useCallback(() => {
    let timer: NodeJS.Timeout | null = null;
    let cancelled = false;
    const fn = () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        Promise.allSettled([
          rewardModalData(),
          sequentialData(),
          getUserDownloadData(),
          exchangeRewardData(),
        ])
          .then(async res => {
            const popList: any[] = [];
            const [rewardSettled, sequentialSettled, appData, exchangeData] =
              res;
            if (
              appData.status === 'fulfilled' &&
              appData.value &&
              shouldShowDailyExtraModal(appData.value.title)
            ) {
              popList.push(appData.value);
            }
            if (
              exchangeData.status === 'fulfilled' &&
              exchangeData.value &&
              shouldShowDailyExtraModal(exchangeData.value.title)
            ) {
              popList.push(exchangeData.value);
            }
            if (
              rewardSettled.status === 'fulfilled' &&
              rewardSettled.value &&
              shouldShowDailyExtraModal(rewardSettled.value.title)
            ) {
              popList.push(rewardSettled.value);
            }
            if (
              sequentialSettled.status === 'fulfilled' &&
              sequentialSettled.value
            ) {
              const visibleSequentialItems =
                await filterRechargeGiftRouteEntries(
                  sequentialSettled.value,
                  (item: any) => item.popUrl,
                  'BANNER',
                );
              const sequentialItems = await Promise.all(
                visibleSequentialItems.map(async (item: any) => {
                  if (item.title === RECHARGE_GIFT_TITLE) {
                    return getRechargeGiftPopupData(item);
                  }
                  return shouldShowSequentialItem(item) ? item : null;
                }),
              );
              popList.push(...sequentialItems.filter(Boolean));
            }
            return popList;
          })
          .then(data => {
            if (cancelled) {
              return;
            }
            console.log(data);
            checkPop(data);
          });
      }, 1000);
    };
    // 数据更新
    sequentialStorage.on('updated', fn);
    sequentialStorage.loadData();
    return () => {
      cancelled = true;
      if (timer) {
        clearTimeout(timer);
      }
      console.log('销毁');
      sequentialStorage.off('updated');
      if (currentModalId.current === HOME_SEQUENTIAL) {
        hideModal(HOME_SEQUENTIAL);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const off = updatePops();
    return off;
  }, [updatePops]);
  return null;
}
